import generateUUID from '@/legacy/ts/generateUUID'

export const overlayList: string[] = []

export function generateUniqueId() {
	return generateUUID()
}

export function addOverlayListItem(id: string) {
	if (id && !overlayList.includes(id)) {
		overlayList.push(id)
		addNoScrollClass()
	}
}

export function removeOverlayListItem(id: string) {
	if (id && overlayList.includes(id)) {
		const index = overlayList.findIndex(item => item === id)
		overlayList.splice(index, 1)
		if (!overlayList.length) {
			removeNoScrollClass()
		}
	}
}

export function addNoScrollClass() {
	document.body.classList.add('bs-no-scroll')
}

export function removeNoScrollClass() {
	document.body.classList.remove('bs-no-scroll')
}
